import { Component, OnInit, OnDestroy, Inject } from "@angular/core";

import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

@Component({
  selector: "app-logout",
  template: ``
})
export class LogoutComponent implements OnInit, OnDestroy {
  constructor(
    protected configService: AppConfigService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {}

  async ngOnInit() {
    sessionStorage.clear();
    localStorage.clear();
    await this.oktaAuth.signOut();
  }

  ngOnDestroy() {}
}
